export default "__VITE_ASSET__pMxpNclO__"